import { PropsWithChildren } from 'react';
import {
	DashboardSidePanelContainer,
	SidePanelResizer,
} from '@dealstack/frontend/shared/layout/DashboardGrid/SidePanels/styled.tsx';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader.tsx';
import { useResizablePanel } from '@dealstack/frontend/shared/layout/DashboardGrid/SidePanels/utils.ts';
import { Flex } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	isLoading?: boolean;
	isOpened: boolean;
	allowResizing?: boolean;
}

export const LeftPanel = ({
	isLoading,
	isOpened,
	allowResizing,
	children,
}: PropsWithChildren<Props>) => {
	const { width, handleMouseDown, isResizing } = useResizablePanel({ side: 'left' });

	return (
		<DashboardSidePanelContainer
			data-testid={TEST_ELEMENT_IDS.LEFT_PANEL}
			$isSidePanelOpen={isOpened}
			$width={width}
			$isResizing={isResizing.current}
			$allowResizing={allowResizing}
			role="complementary"
			$side="left"
		>
			{isLoading ? <InlineLoader /> : null}
			<Flex direction="column" p="1rem" pb="0" h="100%" style={{ overflow: 'hidden' }}>
				{children}
			</Flex>
			{allowResizing && (
				<SidePanelResizer
					onMouseDown={(e) => {
						e.preventDefault(); // prevent text selection
						handleMouseDown();
					}}
					role="separator"
					side="left"
				/>
			)}
		</DashboardSidePanelContainer>
	);
};
